export default __webpack_public_path__ + "static/icon-13-4-5b0dd2b8000a0234702585fcec592d0b.png";